import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IFormController, IScope} from "angular";
import {StateService} from "@uirouter/angularjs";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {LisensavtaleAkseptert} from "web/moduler/gruppe/modale/lisensavtale/lisensavtaleDialog";
import {Språkvalg} from "../../../../felles/tjenester/i18n/Spraakvalg";
import {Tidssonevalg} from "../../../../felles/tjenester/i18n/Tidssonevalg";

const css = require('./opprett.scss');

export class OpprettGruppeKontroller {
    static regNavn = "OpprettGruppeKontroller";

    static forInjisering() {
        return [
            regNavn.ng.ui.$state,
            regNavn.ng.$scope,
            WebNavigasjon.regNavn,
            Språkvalg.regNavn,
            Tidssonevalg.regNavn,
            OpprettGruppeKontroller
        ]
    }

    constructor(private $state: StateService,
                private $scope: IScope,
                private navigasjon: WebNavigasjon,
                private språkvalg: Språkvalg,
                private tidssonevalg: Tidssonevalg) {
        if (!$state.current.data.modell)
            $state.current.data.modell = NyGruppeOgBrukerModell.nyGruppeOgBrukerModell(språkvalg, tidssonevalg);
        this.modell = $state.current.data.modell;
    }

    modell: NyGruppeOgBrukerModell;

    nesteSteg(skjema: IFormController) {
        if (skjema.$invalid) return;
        this.navigasjon.gåTilRegistrerGruppeOgBrukerSteg2();
    }
}

export class NyGruppeOgBrukerModell {

    static nyGruppeOgBrukerModell(språkvalg: Språkvalg, tidssonevalg:Tidssonevalg): NyGruppeOgBrukerModell {
        const modell = new NyGruppeOgBrukerModell();
        modell.spesifikasjon.bruker.spraak = språkvalg.aktivtSpråk().servertag;
        modell.spesifikasjon.bruker.tidssone = tidssonevalg.aktivTidssone();
        return modell;
    }

    constructor() {
        this.spesifikasjon = {
            bruker: {
                epost: '',
                passord: '',
                navn: '',
                spraak: null,
                tidssone: null
            },
            gruppe: {
                gruppenavn: '',
                organisasjonsnavn: '',
                moetenavn: '',
                mal: null,
                tidssone: '',
                spraak: ''
            },
            avtale: {
                navn: '',
                lisensAkseptert: false,
                aksepterteBetingelser: ''
            }
        };
        this.valgtMalgruppe = <l.EnkelGruppeModell>{id: null};
    }

    spesifikasjon: l.NyBrukerOgAvtaleOgGruppeSpesifikasjon;
    valgtMalgruppe: l.EnkelGruppeModell;

    lisensavtaleAkseptert(akseptert: LisensavtaleAkseptert) {
        this.spesifikasjon.avtale.lisensAkseptert = akseptert.akseptert;
        this.spesifikasjon.avtale.aksepterteBetingelser = akseptert.aksepterteBetingelser;
    }

    oppdaterGruppeFraMal(skjema: IFormController) {
        if (!this.valgtMalgruppe.id) return;

        //oppdater ihht mal dersom bruker ikke har redigert feltene
        if (skjema['gruppenavn'].$pristine)
            this.spesifikasjon.gruppe.gruppenavn = this.valgtMalgruppe.tittel;
        if (skjema['moetenavn'].$pristine)
            this.spesifikasjon.gruppe.moetenavn = this.valgtMalgruppe.moetenavn;
    }

    somSpesifikasjon(): l.NyBrukerOgAvtaleOgGruppeSpesifikasjon {
        this.spesifikasjon.gruppe.mal = this.valgtMalgruppe.id;
        this.spesifikasjon.gruppe.organisasjonsnavn = this.spesifikasjon.avtale.navn;
        this.spesifikasjon.gruppe.spraak = this.spesifikasjon.bruker.spraak;
        this.spesifikasjon.gruppe.tidssone = this.spesifikasjon.bruker.tidssone;
        return this.spesifikasjon;
    }
}
